import { render, staticRenderFns } from "./CoOther.vue?vue&type=template&id=b7fd14b8&scoped=true&"
import script from "./CoOther.vue?vue&type=script&lang=js&"
export * from "./CoOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fd14b8",
  null
  
)

export default component.exports